import script from "./autocomplete.vue?vue&type=script&setup=true&lang=ts"
export * from "./autocomplete.vue?vue&type=script&setup=true&lang=ts"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./autocomplete.vue?vue&type=style&index=1&id=165b772e&lang=postcss"

const __exports__ = script;

export default __exports__